import { render, staticRenderFns } from "./DateTab.vue?vue&type=template&id=d28f2516&scoped=true"
import script from "./DateTab.vue?vue&type=script&lang=js"
export * from "./DateTab.vue?vue&type=script&lang=js"
import style0 from "./DateTab.vue?vue&type=style&index=0&id=d28f2516&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28f2516",
  null
  
)

export default component.exports